import { CommonModule, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { FabGmLogoModule } from '@fabric/components/gm-logo';
import { FormStatusPipe } from '../pipes/form-status-pipe';
import { MinusSignToParens } from '../pipes/minus-sign-to-parens';
import { SafeHtmlPipe } from '../pipes/safe-html.pipe';
import { YesNoPipe } from '../pipes/yes-no.pipe';
import { CurrencyFormatterDirective } from './directives/currency-formatter.directive';
import { NumberOnlyDirective } from './directives/number-only.directive';
import { PopupDialogComponent } from './popup-dialog/popup-dialog.component';
import { ProgressSpinnerComponent } from './progress-spinner/progress-spinner.component';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatFormFieldModule,
    MatPaginatorModule,
    MatSortModule,
    MatMenuModule,
    MatTableModule,
    MatSidenavModule,
    MatProgressSpinnerModule,
    MatDatepickerModule,
    FormsModule,
    ReactiveFormsModule,
    MatNativeDateModule,
    MatSelectModule,
    MatDialogModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatTabsModule,
    MatAutocompleteModule,
    MatExpansionModule,
    MatAutocompleteModule,
    MatRadioModule,
    FabGmLogoModule
  ],
  declarations: [
    ProgressSpinnerComponent,
    PopupDialogComponent,
    SafeHtmlPipe,
    YesNoPipe,
    FormStatusPipe,
    MinusSignToParens,
    NumberOnlyDirective,
    CurrencyFormatterDirective,
  ],
  providers: [DecimalPipe],
  exports: [
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatFormFieldModule,
    MatMenuModule,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    MatSidenavModule,
    MatProgressSpinnerModule,
    ProgressSpinnerComponent,
    PopupDialogComponent,
    MatDatepickerModule,
    FormsModule,
    ReactiveFormsModule,
    MatNativeDateModule,
    MatSelectModule,
    MatDialogModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatTabsModule,
    YesNoPipe,
    FormStatusPipe,
    MinusSignToParens,
    MatAutocompleteModule,
    MatExpansionModule,
    MatAutocompleteModule,
    MatRadioModule,
    NumberOnlyDirective,
    CurrencyFormatterDirective,
    FabGmLogoModule
  ]
})
export class SharedModule { }
